export default __webpack_public_path__ + "static/media/news33.3de2c09b.jpg";